import { quoteServiceAddReviewSchema, type QuoteServiceAddReview } from './quoteReviewContract';
const PRESENTER = 'confirmation.presenters.addQuoteService';
export function parseQuoteServiceAddReview(
  params: Record<string, unknown>,
  presenter?: string,
  tool?: string
): { kind: 'absent' } | { kind: 'invalid' } | { kind: 'review'; review: QuoteServiceAddReview } {
  const expected = presenter === PRESENTER || tool === 'add_quote_service';
  if (!('quoteServiceAddReview' in params)) return { kind: expected ? 'invalid' : 'absent' };
  const parsed = quoteServiceAddReviewSchema.safeParse(params.quoteServiceAddReview);
  if (!expected || presenter !== PRESENTER || !parsed.success) return { kind: 'invalid' };
  // The mirrored shared refinement owns the complete append invariant. Keeping
  // a second first-service-only predicate here would reject valid appends.
  return { kind: 'review', review: parsed.data };
}
